const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FasterPayments24 = function FasterPayments24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#176FC1",
      d: "M3.927 16.693h-.252l-.252 1.403h.245c.582 0 .842-.301.842-.866 0-.356-.197-.537-.583-.537Zm-.322 2.149h-.316l-.308 1.757H2l.826-4.652h1.297c.764 0 1.424.293 1.424 1.2 0 1.171-.785 1.695-1.942 1.695Zm3.529-.712c-.363 0-.718.6-.718 1.261 0 .34.08.54.248.54.288 0 .698-.654.852-1.508l.027-.146c-.06-.048-.162-.147-.41-.147Zm.899 2.469h-.906l.08-.468c-.153.24-.382.535-.898.535-.43 0-.846-.335-.846-1.175 0-1.208.718-2.096 1.55-2.096.47 0 .643.194.705.254l.033-.186h.839l-.557 3.136Zm2.527-.194c-.462.92-.924 1.46-1.998 1.595l-.1-.654c.409-.127.824-.333 1.053-.795l.093-.186-.55-2.903h.96l.241 1.708.792-1.708h.999l-1.49 2.943Zm5.877.194h-.905l.369-2.069c.026-.133.02-.267-.134-.267-.282 0-.786.668-.926 1.468l-.154.868h-.907l.37-2.069c.026-.133.02-.267-.134-.267-.282 0-.785.668-.927 1.468l-.153.868h-.905l.556-3.136h.905l-.127.734c.201-.328.517-.802 1.06-.802.49 0 .704.314.67.815.175-.288.504-.815 1.08-.815.558 0 .759.408.644 1.048l-.382 2.156Zm2.637-2.563c-.282 0-.55.354-.658.861.597-.08.96-.22.96-.568 0-.2-.122-.293-.302-.293Zm-.705 1.376c.014.345.162.52.463.52.349 0 .684-.18.933-.334l.248.587c-.208.154-.658.481-1.308.481-.704 0-1.268-.34-1.268-1.288 0-1.102.61-1.983 1.684-1.983.805 0 1.153.348 1.153.881 0 .868-.71 1.075-1.905 1.136Zm4.911 1.187h-.906l.369-2.069c.027-.133.02-.267-.134-.267-.282 0-.786.668-.926 1.468l-.154.868h-.906l.557-3.136h.906l-.127.734c.2-.328.515-.802 1.059-.802.556 0 .758.408.645 1.048l-.384 2.156Zm2.817-2.469h-.47l-.274 1.548c-.028.134.02.2.12.2a.58.58 0 0 0 .256-.066l.093.62c-.134.087-.39.234-.752.234-.469 0-.743-.294-.63-.928l.282-1.608h-.335l.12-.667h.335l.188-.681.873-.187-.155.868h.47l-.12.667Zm2.529.287c-.195-.134-.504-.28-.744-.28-.189 0-.316.066-.316.22 0 .14.141.2.33.28l.173.073c.322.133.678.347.678.907 0 .668-.356 1.049-1.16 1.049-.658 0-1.041-.288-1.282-.46l.355-.621c.235.172.604.34.846.34.208 0 .294-.074.294-.227 0-.154-.147-.221-.334-.294l-.182-.073c-.32-.127-.664-.34-.664-.895 0-.72.558-1.04 1.255-1.04.563 0 .913.28 1.073.4l-.322.62Zm-12.179-6.314h-1.956l-.19 1.082h1.515l-.14.801h-1.514l-.351 1.967h-.982l.828-4.651h2.937l-.147.801Zm1.236 1.381c-.362 0-.718.6-.718 1.261 0 .34.08.54.249.54.288 0 .698-.653.851-1.507l.028-.147c-.06-.047-.161-.147-.41-.147Zm.899 2.469h-.906l.08-.467c-.153.24-.381.534-.898.534-.43 0-.845-.334-.845-1.174 0-1.208.718-2.096 1.549-2.096.47 0 .644.194.705.254l.034-.187h.838l-.557 3.136Zm3.067-2.182c-.195-.134-.504-.28-.745-.28-.188 0-.316.067-.316.22 0 .14.142.2.329.28l.174.074c.322.133.678.346.678.907 0 .668-.356 1.048-1.16 1.048-.658 0-1.04-.287-1.282-.46l.356-.621c.234.173.604.34.845.34.207 0 .295-.073.295-.227 0-.153-.147-.22-.335-.294l-.181-.073c-.322-.127-.664-.34-.664-.894 0-.72.557-1.041 1.254-1.041.563 0 .912.28 1.073.4l-.321.621Zm2.515-.287h-.47l-.275 1.549c-.026.133.02.2.12.2a.58.58 0 0 0 .256-.067l.093.62a1.349 1.349 0 0 1-.75.234c-.47 0-.746-.294-.63-.927l.281-1.61h-.336l.12-.666h.336l.188-.68.872-.188-.155.868h.47l-.12.667Zm1.898-.094c-.282 0-.55.354-.657.86.597-.079.959-.219.959-.566 0-.2-.12-.293-.302-.293Zm-.705 1.375c.014.347.162.52.464.52.349 0 .684-.18.932-.332l.248.586c-.208.154-.658.481-1.308.481-.704 0-1.268-.34-1.268-1.287 0-1.102.61-1.983 1.685-1.983.804 0 1.152.347 1.152.881 0 .868-.71 1.075-1.905 1.134Zm4.469-1.041c-.457 0-.98.387-1.154 1.362l-.155.867h-.905l.557-3.136h.885l-.114.66c.207-.467.45-.727 1.06-.727l-.174.974ZM16.152 8.469v.016c-.002.224-.18.448-.532.617L3.814 14.791c-.71.342-.972.063-.585-.62l2.16-3.818c.313-.557.492-1.2.492-1.884a3.83 3.83 0 0 0-.492-1.884l-2.16-3.819c-.387-.683-.124-.962.585-.62L15.62 7.835c.353.17.53.394.532.618v.016Z",
    })
  );
};
FasterPayments24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 24",
};
const sizeMap = {
  24: FasterPayments24,
};
export function FasterPayments(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FasterPayments' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
